import axios from 'axios';

export async function fetchPredictionData() {
    try {
        const response = await axios.get('https://ia.poc.mv-toth.com/predicao');
        return response.data;
    } catch (error) {
        console.error('Error fetching prediction data:', error);
        throw error;
    }
}